import { create } from "zustand";
import { persist } from "zustand/middleware";

type DesktopSidebar = {
	isHidden: boolean; // desides if the sidebar is completely hidden
	toggleHidden: () => void;
	isExpanded: boolean; // decides if the sidebar has full width or collapsed width
	toggleExpanded: () => void;
};

export const useDesktopSidebar = create<DesktopSidebar>()(
	persist(
		(set) => ({
			isHidden: false,
			toggleHidden: () => set((state) => ({ isHidden: !state.isHidden })),
			isExpanded: true,
			toggleExpanded: () => set((state) => ({ isExpanded: !state.isExpanded })),
		}),
		{ name: "desktop-sidebar-state" },
	),
);
